// = Libs =
import { FC, useState } from 'react';

// = Styles =
// = Imports =
import classes from './report-action-panel.module.scss';
import Button from '@/common/components/ui/buttons/button/button';
import FileUploader from '@/common/components/ui/file-uploader/file-uploader';
import { withAlert } from '@/helpers/notificationHelper';
import { commitReport } from '@/services/report.service';
import { assistantService } from '@/services/assistant/assistant.service';
import clsx from 'clsx';

const ReportActionPanel: FC<{
  reportId: number;
  disabled?: boolean;
  canSubmit?: boolean;
  confirmRequired: boolean;
}> = (props) => {
  const { reportId, disabled, canSubmit = true, confirmRequired } = props;
  const [fileId, setFileId] = useState(-1);

  return (
    <div className={classes['action-panel']}>
      <h3>Скачать отчет</h3>
      <div className={classes['export-buttons']}>
        {['xlsx', 'docx', 'pdf'].map((ext) => {
          return (
            <Button
              className={clsx({
                [classes[`button--${ext}`]]: true,
                [classes[`button`]]: true,
              })}
              onClick={() =>
                withAlert(
                  () =>
                    assistantService.getLocalReport(
                      reportId,
                      ext as 'xlsx' | 'docx' | 'pdf'
                    ),
                  'Файл скачан',
                  ''
                )
              }>
              {ext}
            </Button>
          );
        })}
      </div>
      {canSubmit && (
        <div className={classes['submit-panel']}>
          <h3>Загрузить {confirmRequired && 'подписанный '}отчет</h3>
          {confirmRequired && (
            <FileUploader
              initialId={-1}
              onChangeId={setFileId}
              isNew={fileId === -1}
            />
          )}
          <Button
            color={!disabled ? 'primary' : 'third'}
            fullWidth
            onClick={() => {
              !disabled &&
                withAlert(() =>
                  commitReport(reportId, fileId, confirmRequired)
                );
            }}>
            Отправить {confirmRequired && 'на утверждение'}
          </Button>
          {disabled && (
            <p className={classes.hint}>
              Заполните все поля для отправки отчета на утверждение
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ReportActionPanel;
